<template>
  <div class="container">
    <div class="white-frame">
      <div class="title-text mb-3">
        <b>Dados do Embarque</b>
      </div>

      <!-- Remetente e Origem -->
      <div class="row g-3">
        <div
          class="col-md-6"
          :class="getFieldValidationClass('ProcessoGDM.ProdutoRecebidoContacto.Nome')"
        >
          <label class="form-label" for="remetente">Remetente</label>
          <InputText
            id="remetente"
            v-model="objDTO.ProcessoGDM.ProdutoRecebidoContacto.Nome"
            class="form-control"
          />
        </div>
        <!-- País Origem -->
        <div class="col-md-4" :class="getFieldValidationClass('Transporte.PaisOrigem')">
          <label class="form-label" for="paisOrigem">País Origem</label>
          <Dropdown
            id="paisOrigem"
            v-model="objDTO.Transporte.PaisOrigem"
            :options="paises"
            option-label="Description"
            option-value="Id"
            placeholder="Selecione o país"
            :filter="true"
            :show-clear="true"
            class="form-control w-100"
            @change="handlePaisOrigemChange"
          />
        </div>
        <!-- UF Origem -->
        <div class="col-md-4" :class="getFieldValidationClass('Transporte.EstadoOrigem')">
          <label class="form-label" for="estadoOrigem">UF Origem</label>
          <Dropdown
            v-if="objDTO.Transporte.PaisOrigem === brasilPaisId"
            id="estadoOrigem"
            v-model="objDTO.Transporte.EstadoOrigem"
            :options="estadosOrigem"
            option-label="Description"
            option-value="Id"
            placeholder="Selecione o estado"
            :filter="true"
            :show-clear="true"
            class="form-control w-100"
            :loading="loadingEstadosOrigem"
            :disabled="
              !objDTO.Transporte.PaisOrigem || objDTO.Transporte.PaisOrigem !== brasilPaisId
            "
            @change="handleEstadoOrigemChange"
          />
          <InputText
            v-else
            id="estadoOrigemTexto"
            v-model="objDTO.Transporte.EstadoOrigemTexto"
            class="form-control"
            placeholder="Digite o estado de origem"
          />
        </div>
        <!-- Cidade Origem -->
        <div class="col-md-4" :class="getFieldValidationClass('Transporte.CidadeOrigem')">
          <label class="form-label" for="cidadeOrigem">Cidade Origem</label>
          <Dropdown
            v-if="objDTO.Transporte.PaisOrigem === brasilPaisId"
            id="cidadeOrigem"
            v-model="objDTO.Transporte.CidadeOrigem"
            :options="cidadesOrigem"
            option-label="Description"
            option-value="Id"
            placeholder="Selecione a cidade"
            :filter="true"
            :show-clear="true"
            class="form-control w-100"
            :loading="loadingCidadesOrigem"
            :disabled="!objDTO.Transporte.EstadoOrigem"
          />
          <InputText
            v-else
            id="cidadeOrigemTexto"
            v-model="objDTO.Transporte.CidadeOrigemTexto"
            class="form-control"
            placeholder="Digite a cidade de origem"
          />
        </div>
      </div>

      <!-- Destinatário e Destino -->
      <div class="row g-3 mt-2">
        <div
          class="col-md-12"
          :class="getFieldValidationClass('ProcessoGDM.ProdutoEnvioContacto.Nome')"
        >
          <label class="form-label" for="destinatario">Destinatário</label>
          <InputText
            id="destinatario"
            v-model="objDTO.ProcessoGDM.ProdutoEnvioContacto.Nome"
            class="form-control"
          />
        </div>
      </div>

      <!-- Destino -->
      <div class="row g-3 mt-2">
        <div class="col-md-4">
          <label class="form-label" for="embarquePaisDestino">País Destino</label>
          <Dropdown
            id="embarquePaisDestino"
            v-model="objDTO.EmbarqueTransporte.PaisDestino"
            :options="paises"
            option-label="Description"
            option-value="Id"
            placeholder="Selecione o país"
            :filter="true"
            :show-clear="true"
            class="form-control w-100"
            @change="handlePaisDestinoChange"
          />
        </div>
        <div class="col-md-4">
          <label class="form-label" for="embarqueEstadoDestino">Estado Destino</label>
          <Dropdown
            v-if="objDTO.EmbarqueTransporte.PaisDestino === brasilPaisId"
            id="embarqueEstadoDestino"
            v-model="objDTO.EmbarqueTransporte.EstadoDestino"
            :options="estadosDestino"
            option-label="Description"
            option-value="Id"
            placeholder="Selecione o estado"
            :filter="true"
            :show-clear="true"
            class="form-control w-100"
            :loading="loadingEstados"
            :disabled="
              !objDTO.EmbarqueTransporte.PaisDestino ||
              objDTO.EmbarqueTransporte.PaisDestino !== brasilPaisId
            "
            @change="handleEstadoDestinoChange"
          />
          <InputText
            v-else
            id="estadoDestinoTexto"
            v-model="objDTO.EmbarqueTransporte.EstadoDestinoTexto"
            class="form-control"
            placeholder="Digite o estado de destino"
          />
        </div>
        <div class="col-md-4">
          <label class="form-label" for="embarqueCidadeDestino">Cidade Destino</label>
          <Dropdown
            v-if="objDTO.EmbarqueTransporte.PaisDestino === brasilPaisId"
            id="embarqueCidadeDestino"
            v-model="objDTO.EmbarqueTransporte.CidadeDestino"
            :options="cidadesDestino"
            option-label="Description"
            option-value="Id"
            placeholder="Selecione a cidade"
            :filter="true"
            :show-clear="true"
            class="form-control w-100"
            :loading="loadingCidades"
            :disabled="!objDTO.EmbarqueTransporte.EstadoDestino"
          />
          <InputText
            v-else
            id="cidadeDestinoTexto"
            v-model="objDTO.EmbarqueTransporte.CidadeDestinoTexto"
            class="form-control"
            placeholder="Digite a cidade de destino"
          />
        </div>
      </div>

      <!-- Valor Declarado e Fatura -->
      <div class="row g-3 mt-2">
        <div class="col-md-6" :class="getFieldValidationClass('EmbarqueTransporte.ValorDeclarado')">
          <label class="form-label" for="valorDeclarado">Valor Declarado</label>
          <InputNumber
            id="valorDeclarado"
            v-model="objDTO.EmbarqueTransporte.ValorDeclarado"
            mode="currency"
            currency="BRL"
            locale="pt-BR"
            class="form-control p-0"
          />
        </div>
        <div class="col-md-6">
          <label class="form-label" for="faturaNF">Fatura / Nota Fiscal</label>
          <InputText
            id="faturaNF"
            v-model="objDTO.EmbarqueTransporte.FaturaNr"
            class="form-control"
          />
        </div>
      </div>

      <!-- Conhecimento e Manifesto -->
      <div class="row g-3 mt-2">
        <div class="col-md-6">
          <label class="form-label" for="numeroConhecimento">Número Conhecimento</label>
          <InputText
            id="numeroConhecimento"
            v-model="objDTO.EmbarqueTransporte.NumeroConhecimento"
            class="form-control"
          />
        </div>
        <div class="col-md-6">
          <label class="form-label" for="manifesto">Manifesto</label>
          <InputText
            id="manifesto"
            v-model="objDTO.EmbarqueTransporte.Manifesto"
            class="form-control"
          />
        </div>
      </div>

      <!-- Data Embarque e Mercadoria -->
      <div class="row g-3 mt-2">
        <div class="col-md-6" :class="getFieldValidationClass('EmbarqueTransporte.DataEmbarque')">
          <label class="form-label" for="dataEmbarque">Data do Embarque</label>
          <Calendar
            id="dataEmbarque"
            v-model="objDTO.EmbarqueTransporte.DataEmbarque"
            date-format="dd/mm/yy"
            :show-icon="true"
            class="form-control p-0"
            :manual-input="true"
          />
        </div>
        <div class="col-md-6" :class="getFieldValidationClass('EmbarqueTransporte.Mercadoria')">
          <label class="form-label" for="mercadoria">Mercadoria</label>
          <Dropdown
            id="mercadoria"
            v-model="objDTO.EmbarqueTransporte.Mercadoria"
            :options="mercadorias"
            option-label="Description"
            option-value="Id"
            placeholder="Selecione a mercadoria"
            class="form-control w-100"
            :filter="true"
            :show-clear="true"
            @change="handleMercadoriaChange"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import InputText from 'primevue/inputtext';
  import InputNumber from 'primevue/inputnumber';
  import Dropdown from 'primevue/dropdown';
  import Calendar from 'primevue/calendar';
  import { getDistricts, getCities as getConcelhosByDistrictId } from '../../../api/formMethods';

  // ID do Brasil na lista de países
  const BRASIL_PAIS_ID = 3;

  // Lista de mercadorias disponíveis
  const MERCADORIAS = [
    { Id: 1, Description: 'Alimentos Perecíveis' },
    { Id: 2, Description: 'Alimentos Não-Perecíveis' },
    { Id: 3, Description: 'Eletrônicos' },
    { Id: 4, Description: 'Têxteis' },
    { Id: 5, Description: 'Produtos Químicos' },
    { Id: 6, Description: 'Equipamentos Industriais' },
    { Id: 7, Description: 'Móveis' },
    { Id: 8, Description: 'Materiais de Construção' },
    { Id: 9, Description: 'Veículos e Peças' },
    { Id: 10, Description: 'Medicamentos' },
    { Id: 11, Description: 'Outros' }
  ];

  /**
   * Componente para gerenciar dados de embarque no módulo de Transporte
   * Responsável por coletar informações sobre origem, destino, valor e outros
   * dados relacionados ao embarque
   */
  export default {
    name: 'DadosEmbarque',
    components: { InputText, InputNumber, Dropdown, Calendar },
    props: {
      // Objeto de validação proveniente do componente pai
      validation: {
        type: Object,
        default: () => ({})
      },
      // Indica se os dados estão sendo carregados
      isLoadingData: {
        type: Boolean,
        default: false
      },
      // Flag que indica se o Brasil está selecionado como país
      isBrasilSelected: {
        type: Boolean,
        default: true
      }
    },
    data() {
      return {
        // Constante para referência ao ID do Brasil
        brasilPaisId: BRASIL_PAIS_ID,
        // Listas de estados e cidades para os selects
        estadosDestino: [],
        cidadesDestino: [],
        estadosOrigem: [],
        cidadesOrigem: [],
        // Flags de carregamento para os dropdowns
        loadingEstados: false,
        loadingCidades: false,
        loadingEstadosOrigem: false,
        loadingCidadesOrigem: false,
        // Lista de mercadorias disponíveis
        mercadorias: MERCADORIAS
      };
    },
    computed: {
      // Mapeamento de getters do Vuex
      ...mapGetters({
        objDTO: 'getObjDTO',
        paises: 'getCountries'
      })
    },
    /**
     * Inicializa o componente carregando dados necessários e
     * configurando valores iniciais
     */
    async mounted() {
      // Inicializar estruturas necessárias para evitar erros de propriedades indefinidas
      this.initializeStructures();

      // Carregar países do store
      await this.$store.dispatch('getOrSetCountries');

      // Carregar localidades se já estiverem selecionadas
      await this.carregarLocalidadesIniciais();

      // Inicializa a data de embarque se não estiver definida
      if (!this.objDTO?.EmbarqueTransporte?.DataEmbarque) {
        this.updateObjDTO('EmbarqueTransporte.DataEmbarque', null);
      }
    },
    methods: {
      /**
       * Carrega estados e cidades se já estiverem selecionados previamente
       * Útil para recuperação de estado em edição ou após navegação
       */
      async carregarLocalidadesIniciais() {
        // Se já tiver um país selecionado, carregar os estados correspondentes para destino
        if (this.objDTO?.EmbarqueTransporte?.PaisDestino === this.brasilPaisId) {
          await this.handlePaisDestinoChange();

          // Se já tiver um estado selecionado, carregar as cidades
          if (this.objDTO?.EmbarqueTransporte?.EstadoDestino) {
            await this.handleEstadoDestinoChange();
          }
        }

        // Se já tiver um país selecionado para origem, carregar os estados correspondentes
        if (this.objDTO?.Transporte?.PaisOrigem === this.brasilPaisId) {
          await this.handlePaisOrigemChange();

          // Se já tiver um estado selecionado, carregar as cidades
          if (this.objDTO?.Transporte?.EstadoOrigem) {
            await this.handleEstadoOrigemChange();
          }
        }
      },

      /**
       * Retorna a classe CSS de validação para um campo específico
       * @param {string} fieldPath - Caminho do campo no objeto de validação (ex: 'Sinistro.SinistroMorada')
       * @returns {Object} - Objeto com classes CSS a serem aplicadas
       */
      getFieldValidationClass(fieldPath) {
        return {
          'field-required': this.isFieldInvalid(fieldPath)
        };
      },

      /**
       * Verifica se um campo específico é inválido com base no caminho
       * @param {string} fieldPath - Caminho do campo no objeto de validação
       * @returns {boolean} - Verdadeiro se o campo for inválido
       */
      isFieldInvalid(fieldPath) {
        if (!this.validation || !this.validation.objDTO) {
          return false;
        }

        const parts = fieldPath.split('.');
        let current = this.validation.objDTO;

        for (const part of parts) {
          if (!current[part]) {
            return false;
          }
          current = current[part];
        }

        return current.$invalid;
      },

      /**
       * Atualiza um valor no objDTO de forma segura, garantindo que os objetos pai existam
       * @param {string} path - Caminho da propriedade a ser atualizada (ex: 'Sinistro.SinistroMorada')
       * @param {any} value - Valor a ser definido
       */
      updateObjDTO(path, value) {
        const newObjDTO = { ...this.objDTO };
        const parts = path.split('.');

        let current = newObjDTO;
        for (let i = 0; i < parts.length - 1; i++) {
          if (!current[parts[i]]) {
            current[parts[i]] = {};
          }
          current = current[parts[i]];
        }

        current[parts[parts.length - 1]] = value;
        this.$store.commit('setObjDTO', newObjDTO);
      },

      /**
       * Limpa os campos de texto relacionados a localidades
       * @param {string} tipoLocalidade - 'origem' ou 'destino'
       */
      limparCamposLocalidade(tipoLocalidade) {
        if (tipoLocalidade === 'origem') {
          // Limpa campos de origem
          this.objDTO.Transporte.EstadoOrigem = null;
          this.objDTO.Transporte.CidadeOrigem = null;
          this.estadosOrigem = [];
          this.cidadesOrigem = [];

          // Se não for Brasil, limpa os campos de texto
          if (this.objDTO.Transporte.PaisOrigem !== this.brasilPaisId) {
            this.objDTO.Transporte.EstadoOrigemTexto = '';
            this.objDTO.Transporte.CidadeOrigemTexto = '';
          }
        } else {
          // Limpa campos de destino
          this.objDTO.EmbarqueTransporte.EstadoDestino = null;
          this.objDTO.EmbarqueTransporte.CidadeDestino = null;
          this.estadosDestino = [];
          this.cidadesDestino = [];

          // Se não for Brasil, limpa os campos de texto
          if (this.objDTO.EmbarqueTransporte.PaisDestino !== this.brasilPaisId) {
            this.objDTO.EmbarqueTransporte.EstadoDestinoTexto = '';
            this.objDTO.EmbarqueTransporte.CidadeDestinoTexto = '';
          }
        }
      },

      // ==============================================
      // INICIALIZAÇÃO DE ESTRUTURAS
      // ==============================================

      /**
       * Inicialização principal do objeto DTO e suas estruturas
       * Garante que todas as propriedades necessárias existam
       */
      initializeStructures() {
        this.initializeMainObject();
        this.initializeProcessoGDM();
        this.initializeEmbarqueTransporte();
        this.initializeTransporte();
      },

      /**
       * Inicializa o objeto principal
       */
      initializeMainObject() {
        if (!this.objDTO) {
          this.$store.commit('setObjDTO', {});
        }
      },

      /**
       * Inicializa estrutura ProcessoGDM com informações de contato
       */
      initializeProcessoGDM() {
        if (!this.objDTO.ProcessoGDM) {
          this.$store.commit('setObjDTO', {
            ...this.objDTO,
            ProcessoGDM: {
              ProdutoRecebidoContacto: {
                Nome: '',
                Morada: '',
                Telefone: '',
                Email: ''
              },
              ProdutoEnvioContacto: {
                Nome: '',
                Morada: '',
                Telefone: '',
                Email: ''
              }
            }
          });
          return;
        }

        const processoGDM = { ...this.objDTO.ProcessoGDM };
        let isModified = false;

        // Verificar e inicializar ProdutoRecebidoContacto
        if (!processoGDM.ProdutoRecebidoContacto) {
          processoGDM.ProdutoRecebidoContacto = {
            Nome: '',
            Morada: '',
            Telefone: '',
            Email: ''
          };
          isModified = true;
        }

        // Verificar e inicializar ProdutoEnvioContacto
        if (!processoGDM.ProdutoEnvioContacto) {
          processoGDM.ProdutoEnvioContacto = {
            Nome: '',
            Morada: '',
            Telefone: '',
            Email: ''
          };
          isModified = true;
        }

        // Só atualiza o store se houver alterações
        if (isModified) {
          this.$store.commit('setObjDTO', {
            ...this.objDTO,
            ProcessoGDM: processoGDM
          });
        }
      },

      /**
       * Inicializa estrutura EmbarqueTransporte com valores padrão
       */
      initializeEmbarqueTransporte() {
        if (!this.objDTO.EmbarqueTransporte) {
          this.$store.commit('setObjDTO', {
            ...this.objDTO,
            EmbarqueTransporte: {
              ValorDeclarado: 0,
              FaturaNr: '',
              NumeroConhecimento: '',
              Manifesto: '',
              DataEmbarque: null,
              Mercadoria: null,
              Destino: '',
              // Campos para localidade
              PaisDestino: null,
              EstadoDestino: null,
              CidadeDestino: null,
              // Campos de texto para países estrangeiros
              EstadoDestinoTexto: '',
              CidadeDestinoTexto: ''
            }
          });
          return;
        }

        const embarque = { ...this.objDTO.EmbarqueTransporte };
        let isModified = false;

        // Verificar e inicializar campos
        const fieldsToCheck = [
          { name: 'PaisDestino', defaultValue: null },
          { name: 'EstadoDestino', defaultValue: null },
          { name: 'CidadeDestino', defaultValue: null },
          { name: 'DataEmbarque', defaultValue: null },
          { name: 'EstadoDestinoTexto', defaultValue: '' },
          { name: 'CidadeDestinoTexto', defaultValue: '' }
        ];

        for (const field of fieldsToCheck) {
          if (embarque[field.name] === undefined) {
            embarque[field.name] = field.defaultValue;
            isModified = true;
          }
        }

        // Só atualiza o store se houver alterações
        if (isModified) {
          this.$store.commit('setObjDTO', {
            ...this.objDTO,
            EmbarqueTransporte: embarque
          });
        }
      },

      /**
       * Inicializa estrutura Transporte com informações de origem
       */
      initializeTransporte() {
        if (!this.objDTO.Transporte) {
          this.$store.commit('setObjDTO', {
            ...this.objDTO,
            Transporte: {
              PaisOrigem: null,
              EstadoOrigem: null,
              CidadeOrigem: null,
              // Campos de texto para países estrangeiros
              EstadoOrigemTexto: '',
              CidadeOrigemTexto: ''
            }
          });
          return;
        }

        const transporte = { ...this.objDTO.Transporte };
        let isModified = false;

        // Verificar e inicializar campos
        const fieldsToCheck = [
          { name: 'PaisOrigem', defaultValue: null },
          { name: 'EstadoOrigem', defaultValue: null },
          { name: 'CidadeOrigem', defaultValue: null },
          { name: 'EstadoOrigemTexto', defaultValue: '' },
          { name: 'CidadeOrigemTexto', defaultValue: '' }
        ];

        for (const field of fieldsToCheck) {
          if (transporte[field.name] === undefined) {
            transporte[field.name] = field.defaultValue;
            isModified = true;
          }
        }

        // Só atualiza o store se houver alterações
        if (isModified) {
          this.$store.commit('setObjDTO', {
            ...this.objDTO,
            Transporte: transporte
          });
        }
      },

      // ==============================================
      // FUNÇÕES DE CARREGAMENTO DE LOCALIDADES
      // ==============================================

      /**
       * Função genérica para carregar estados (distritos)
       * @param {string} tipoLocalidade - 'origem' ou 'destino'
       * @returns {Promise<Array>} - Lista de estados carregados
       */
      async carregarEstados(tipoLocalidade) {
        const isPaisOrigem = tipoLocalidade === 'origem';
        const targetArray = isPaisOrigem ? 'estadosOrigem' : 'estadosDestino';
        const loadingFlag = isPaisOrigem ? 'loadingEstadosOrigem' : 'loadingEstados';

        this[loadingFlag] = true;
        try {
          const estados = await this.executarComTratamentoErro(
            getDistricts,
            {},
            `Erro ao carregar estados de ${isPaisOrigem ? 'origem' : 'destino'}`
          );
          this[targetArray] = estados || [];
          return estados;
        } finally {
          this[loadingFlag] = false;
        }
      },

      /**
       * Função genérica para carregar cidades (concelhos)
       * @param {number} estadoId - ID do estado/distrito selecionado
       * @param {string} tipoLocalidade - 'origem' ou 'destino'
       * @returns {Promise<Array>} - Lista de cidades carregadas
       */
      async carregarCidades(estadoId, tipoLocalidade) {
        const isPaisOrigem = tipoLocalidade === 'origem';
        const targetArray = isPaisOrigem ? 'cidadesOrigem' : 'cidadesDestino';
        const loadingFlag = isPaisOrigem ? 'loadingCidadesOrigem' : 'loadingCidades';

        this[loadingFlag] = true;
        try {
          const cidades = await this.executarComTratamentoErro(
            getConcelhosByDistrictId,
            estadoId,
            `Erro ao carregar cidades de ${isPaisOrigem ? 'origem' : 'destino'}`
          );
          this[targetArray] = cidades || [];
          return cidades;
        } finally {
          this[loadingFlag] = false;
        }
      },

      /**
       * Executa uma função com tratamento padronizado de erro
       * @param {Function} funcao - Função a ser executada
       * @param {any} params - Parâmetros para a função
       * @param {string} mensagemErro - Mensagem de erro para log e evento
       * @returns {Promise<any>} - Resultado da função ou array vazio em caso de erro
       */
      async executarComTratamentoErro(funcao, params, mensagemErro) {
        try {
          return await funcao(params);
        } catch (error) {
          console.error(mensagemErro, error);
          this.$emit('erro', { mensagem: mensagemErro, detalhe: error.message });
          return [];
        }
      },

      // ==============================================
      // HANDLERS DE EVENTOS
      // ==============================================

      /**
       * Trata a mudança de mercadoria
       * Emite evento para notificar componentes pais sobre a alteração
       */
      handleMercadoriaChange() {
        // Emite evento informando que a mercadoria foi alterada
        this.$emit('mercadoriaChanged', this.objDTO.EmbarqueTransporte.Mercadoria);

        // Atualiza validação se necessário
        if (this.validation && this.validation.$touch) {
          this.validation.$touch();
        }
      },

      /**
       * Handler para mudança de país de origem
       * Atualiza estados e limpa campos relacionados
       */
      async handlePaisOrigemChange() {
        // Limpa os estados e cidades ao mudar o país
        this.limparCamposLocalidade('origem');

        // Carrega estados apenas se o país for Brasil
        if (this.objDTO.Transporte.PaisOrigem === this.brasilPaisId) {
          await this.carregarEstados('origem');

          // Limpa os campos de texto quando Brasil é selecionado
          this.objDTO.Transporte.EstadoOrigemTexto = '';
          this.objDTO.Transporte.CidadeOrigemTexto = '';
        }

        // Notifica sobre a mudança de país de origem
        this.$emit('paisOrigemChanged', this.objDTO.Transporte.PaisOrigem);
      },

      /**
       * Handler para mudança de estado de origem
       * Carrega cidades associadas ao estado selecionado
       */
      async handleEstadoOrigemChange() {
        // Limpa as cidades ao mudar o estado
        this.cidadesOrigem = [];
        this.objDTO.Transporte.CidadeOrigem = null;

        // Se um estado válido foi selecionado, carrega as cidades
        if (this.objDTO.Transporte.EstadoOrigem) {
          await this.carregarCidades(this.objDTO.Transporte.EstadoOrigem, 'origem');
          // Notifica sobre a mudança de estado
          this.$emit('estadoOrigemChanged', this.objDTO.Transporte.EstadoOrigem);
        }
      },

      /**
       * Handler para mudança de país de destino
       * Atualiza estados e limpa campos relacionados
       */
      async handlePaisDestinoChange() {
        // Limpa os estados e cidades ao mudar o país
        this.limparCamposLocalidade('destino');

        // Carrega estados apenas se o país for Brasil
        if (this.objDTO.EmbarqueTransporte.PaisDestino === this.brasilPaisId) {
          await this.carregarEstados('destino');

          // Limpa os campos de texto quando Brasil é selecionado
          this.objDTO.EmbarqueTransporte.EstadoDestinoTexto = '';
          this.objDTO.EmbarqueTransporte.CidadeDestinoTexto = '';
        }

        // Notifica sobre a mudança de país de destino
        this.$emit('paisDestinoChanged', this.objDTO.EmbarqueTransporte.PaisDestino);
      },

      /**
       * Handler para mudança de estado de destino
       * Carrega cidades associadas ao estado selecionado
       */
      async handleEstadoDestinoChange() {
        // Limpa as cidades ao mudar o estado
        this.cidadesDestino = [];
        this.objDTO.EmbarqueTransporte.CidadeDestino = null;

        // Se um estado válido foi selecionado, carrega as cidades
        if (this.objDTO.EmbarqueTransporte.EstadoDestino) {
          await this.carregarCidades(this.objDTO.EmbarqueTransporte.EstadoDestino, 'destino');
          // Notifica sobre a mudança de estado
          this.$emit('estadoDestinoChanged', this.objDTO.EmbarqueTransporte.EstadoDestino);
        }
      }
    }
  };
</script>

<style scoped>
  .p-dropdown {
    width: 100%;
  }
  .p-calendar {
    width: 100%;
  }
  .p-inputnumber {
    width: 100%;
  }
</style>
